import { Bee } from "../art/Bee.tsx";
import { Button } from "../components/ui.tsx";
import { copy } from "../copy/index.ts";
import styles from "./Entry.module.css";

export function ErrorScreen({ message, onRetry }: { message?: string; onRetry?: () => void }) {
  return (
    <div className={styles.page}>
      <Bee expression="oops" size={150} />
      <p className={styles.subtitle}>{message ?? copy.errors.generic}</p>
      {onRetry && <Button onClick={onRetry}>{copy.errors.retry}</Button>}
    </div>
  );
}
